import React from "react";

// Mock list of available services (keys & labels) - real data can be injected later.
const SERVICES = [
  { key: "closing", label: "Closing/Settlement Services" },
  { key: "commitment", label: "Commitment/Prelim/Binder/Title Policy" },
  { key: "foreclosure", label: "Foreclosure Search/TSG" },
  { key: "ownerships", label: "Ownerships & Encumbrances" },
  { key: "search", label: "Search/Title Report" },
];

const Step2 = ({ formData, updateField, goNext, goPrev }) => {
  const { servicesSelected = [], specialInstructions, dateNeededBy } = formData;

  const toggleService = key => {
    const exists = servicesSelected.includes(key);
    const next = exists
      ? servicesSelected.filter(k => k !== key)
      : [...servicesSelected, key];
    updateField("servicesSelected", next);
  };

  const onInstructionsChange = e => {
    updateField("specialInstructions", e.target.value);
  };

  const onDateChange = e => {
    updateField("dateNeededBy", e.target.value);
  };

  const skip = () => {
    // Clear any selected services & proceed
    updateField("servicesSelected", []);
    goNext();
  };

  return (
    <div className="form-order-services__step form-order-services__step--2">
      <h2 className="form-order-services__step-title txt-h4">
        Select any applicable service you'd like to include
      </h2>

      <div
        className="form-order-services__column-container"
        style={{ alignItems: "flex-start" }}
      >
        <div className="form-order-services__column">
          <div className="form-order-services__services-group">
            <div className="form-order-services__services-heading">
              Title Services
            </div>
            <ul className="form-order-services__services-list">
              {SERVICES.map(svc => (
                <li
                  key={svc.key}
                  className="form-order-services__services-item"
                >
                  <label className="form-order-services__checkbox-option">
                    <input
                      type="checkbox"
                      checked={servicesSelected.includes(svc.key)}
                      onChange={() => toggleService(svc.key)}
                    />
                    <span>{svc.label}</span>
                  </label>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="form-order-services__column">
          <aside className="form-order-services__note-box" role="note">
            If you don’t see a service you’d like to request, use this Special
            Instructions field.
          </aside>
        </div>
      </div>

      <div className="form-order-services__column-container">
        <div className="form-order-services__column">
          <label
            className="form-order-services__group-label"
            htmlFor="specialInstructions"
          >
            Special Instructions
          </label>
          <textarea
            id="specialInstructions"
            name="specialInstructions"
            className="form-order-services__textarea"
            rows={6}
            value={specialInstructions}
            onChange={onInstructionsChange}
          />
        </div>
      </div>

      <div className="form-order-services__column-container">
        <div className="form-order-services__column">
          <label
            className="form-order-services__group-label"
            htmlFor="dateNeededBy"
          >
            Services Needed By
          </label>
          <input
            id="dateNeededBy"
            type="date"
            className="form-order-services__date-input"
            value={dateNeededBy}
            onChange={onDateChange}
          />
        </div>
        {/* Spacer */}
        <div className="form-order-services__column"></div>
      </div>

      <div className="form-order-services__actions">
        <button type="button" className="btn btn--secondary" onClick={goPrev}>
          BACK
        </button>
        <div className="form-order-services__actions-group">
          <button type="button" className="btn btn--secondary" onClick={skip}>
            SKIP
          </button>
          <button type="button" className="btn btn--primary" onClick={goNext}>
            NEXT
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step2;
